import { Autocomplete, TextField } from "@mui/material";

export const accountCategoryFields = [
  {
    name: "categoryName",
    label: "Category Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "currency",
    label: "Currency *",
    type: "text",
    gridColumn: "span 2",
    required: false,
  },
  {
    name: "rate",
    label: "Rate *",
    type: "number",
    gridColumn: "span 2",
    required: false,
  },
  //   {
  //     name: "parentAccount",
  //     label: "Parent Account",
  //     type: "text",
  //     gridColumn: "span 2",
  //   },
  //   {
  //     name: "oldParent",
  //     label: "Old Parent",
  //     type: "text",
  //     gridColumn: "span 2",
  //   }
];
export const accountSubcategoryFields = [
  {
    name: "accountName",
    label: "Category Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  // {
  //   name: "accountNumber",
  //   label: "Account Number *",
  //   type: "number",
  //   gridColumn: "span 2",
  //   required: true,
  // },
  // {
  //   name: "accountType",
  //   label: "Account Type *",
  //   type: "number",
  //   gridColumn: "span 2",
  //   required: false,
  // },

  // {
  //   name: "currency",
  //   label: "Currency *",
  //   type: "text",
  //   gridColumn: "span 2",
  //   required: false,
  // },

  // {
  //   name: "rate",
  //   label: "Rate *",
  //   type: "number",
  //   gridColumn: "span 2",
  //   required: false,
  // },
];
// src/data/DynamicTable/AccountsDynamicForms.tsx

export const accountFields = [
  {
    name: "accountName",
    label: "Account Name",
    type: "text",
    required: true,
    component: TextField,
    //gridProps: { xs: 12, md: 6 },
  },
  {
    name: "accountSubcategoryId",
    label: "Account Subcategory",
    type: "select",
    required: true,
    component: Autocomplete,
    options: (categoryData) =>
      (categoryData || [])
        .filter((c) => c.accountCategoryId === 2)   // <-- your filter
        .map((c) => ({ label: c.accountName, value: c.id })),
    getOptionLabel: (opt) => opt.label,
    isOptionEqualToValue: (opt, val) => opt.value === val,
    //gridProps: { xs: 12, md: 6 },
  },
];
export const SuspendedTransactionsFields = [
  {
    name: "firstName",
    label: "First Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "lastName",
    label: "Last Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "invoiceNumber",
    label: "Invoice Number *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "transAmount",
    label: "Transaction Amount *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];
export const paymentTypeFields = [
  {
    name: "paymentType",
    label: "Payment Type *",
    type: "text",
    gridColumn: "span 4",
    required: true,
  },
];
export const bankFields = [
  {
    name: "bankName",
    label: "Bank Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "bankSwiftCode",
    label: "Bank SWIFT Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "finCode",
    label: "FIN Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "mobile",
    label: "Mobile *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "email",
    label: "Email *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];

export const mpesaProviderFields = [
  {
    name: "providerName",
    label: "Provider Name",
    type: "text",
    required: true,
  },
  {
    name: "shortCode",
    label: "Shortcode (Till/Paybill)",
     gridColumn: "span 2",
    type: "text",
    required: true,
  },
  {
    name: "businessCode",
    label: "Business Code",
     gridColumn: "span 2",
    type: "text",
  },
];


export const bankBranchFields = [
  {
    name: "branchCode",
    label: "Branch Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "branchName",
    label: "Branch Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "branchSwiftCode",
    label: "Branch SWIFT Code *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const bankAccountFields = [
  {
    name: "accountName",
    label: "Account Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountNumber",
    label: "Account Number *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "accountDescription",
    label: "Account Description *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];

export const fiscalYearFields = [
  {
    name: "fiscalYearName",
    label: "Fiscal Year Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "startDate",
    label: "Start Date *",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "endDate",
    label: "End Date *",
    type: "date",
    gridColumn: "span 2",
    required: true,
  },
];
export const taxAuthorityFields = [
  {
    name: "name",
    label: "Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "jurisdiction",
    label: "Jurisdiction *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const taxRateFields = [
  {
    name: "name",
    label: "Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "rate",
    label: "Rate *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];
export const subRightsFields = [
  {
    name: "title",
    label: "Title *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
export const chargeLineFields = [
  {
    name: "description",
    label: "Description",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "price",
    label: "Price *",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
];
export const productFields = [
  {
    name: "productName",
    label: "Product Name *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "costPrice",
    label: "Buying Price *",
    type: "number",
    gridColumn: "span 2",
    required: false,
    parent: "dependent",
  },
];

export const FixedExpenseFields = [
  {
    name: "entry",
    label: "Entry *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "amount",
    label: "Amount ($)",
    type: "number",
    gridColumn: "span 2",
    required: true,
  },
  {
    name: "description",
    label: "Description *",
    type: "text",
    gridColumn: "span 2",
    required: true,
  },
];
